import React, { useContext } from "react";
import styled from "@emotion/styled";
import { Link } from "gatsby";
import ButtonBase from '@mui/material/ButtonBase';
import { heightBreakpoints, forSize } from "../utils/sizeMixins";
import { ThemeContext } from "../contexts/ThemeContext";
import { recordEvent, Events } from "../analytics";

const StyledNavigationItem = styled(ButtonBase)(({ ishighlighted }) => `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: ${ishighlighted === "true" ? 'var(--nav-highlighted)' : 'transparent'};
    padding: 1em;
    width: 100%;
    height: 40px;
    border: none;
    border-radius: 25px;
    outline: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    ${forSize(heightBreakpoints.small, 'down', 'y')} {
        margin: 2px;
    }

    ${forSize(heightBreakpoints.small, 'up', 'y')} {
        margin: 5px;
    }

    @media(hover: hover) {
        &:hover {
            background-color: ${ishighlighted === "true" ? 'var(--nav-highlighted-hover)' : 'var(--nav-highlighted)'};
        }
    }
`);

const StyledNavigationDetails = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;

    span {
        margin-left: 10px;
        font-size: 1.3em;
        font-weight: normal;
        letter-spacing: 0.3px;
    }
`;

const NavigationItem = ({ icon, name, path }) => {

    const { setDashboardFs } = useContext(ThemeContext);

    // Get the current path of the page
    const currentPage = typeof window !== 'undefined' ? window.location.pathname : '';

    // Always remove the trailing slash from the path and current page path
    const currentPagePath = currentPage.replace(/\/$/, '');
    const pathWithoutTrailingSlash = path.replace(/\/$/, '');

    // Check if the current page path is the same as the path of the navigation item
    const isHighlighted = currentPagePath !== '' ? currentPagePath.includes(pathWithoutTrailingSlash) && pathWithoutTrailingSlash !== '' : currentPagePath === pathWithoutTrailingSlash;

    const resetFs = () => setDashboardFs(false);

    const analyticsCaptureClick = () => {
        recordEvent(Events.NAVIGATION_ITEM_CLICKED);
    }

    return (
        <Link 
            to={path} 
            style={{ textDecoration: 'none' }} 
            state={{ launchAnimationCompleted: true }} 
            draggable={false} 
            onClickCapture={analyticsCaptureClick}
            onClick={resetFs}
        >
            <StyledNavigationItem ishighlighted={isHighlighted.toString()}>
                <StyledNavigationDetails>
                    {icon}
                    <span>{name}</span>
                </StyledNavigationDetails>
            </StyledNavigationItem>
        </Link>
    )
}

export default NavigationItem;